import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, BadgeText } from './InfoBadge.style';
const InfoBadge = ({ icon, children, backgroundColor, textColor }) => (_jsxs(Badge, { backgroundColor: backgroundColor, children: [icon, _jsx(BadgeText, { textColor: textColor, children: children })] }));
InfoBadge.defaultProps = {
    backgroundColor: undefined,
    textColor: undefined
};
export default InfoBadge;
